import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  messagesPlaceholder: {
    marginTop: 30,
    padding: 10,
    backgroundColor: theme.palette.colors.warning,
    borderRadius: 8,
  },
  loader: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/useStyles.js